module.exports = __webpack_public_path__ + "img/insec_Right to Assembly.c38dea77.svg";